module.exports = require("core-js/library/fn/number/is-integer");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/number/is-integer.js
// module id = 1180
// module chunks = 0